import React from 'react'
import { ChevronLeft, ChevronRight } from 'react-feather'
import styled, { useTheme } from 'styled-components'
import { SpaceProps } from 'styled-system'
import { ButtonProps, IconButton } from '../../Button'

const IconWrapper = styled(IconButton)<{ faded?: boolean }>`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  opacity: ${({ faded }) => (faded ? 0.3 : 1)};
  background: ${({ theme }) => theme.colors.gray10} important!;
  padding: 0px;
  user-select: none;
  transition: all 0.3s ease-in-out;
  svg {
    height: 100%;
    width: 80%;
  }
  :hover:not(:disabled) {
    border: 1px solid ${({ theme }) => theme.colors.purple} !important;
  }
`

export enum ArrowDirection {
  LEFT = 'left',
  RIGHT = 'right'
}

export type TableArrowProps = {
  direction: ArrowDirection
  faded?: boolean
} & ButtonProps &
  SpaceProps

const TableArrow: React.FunctionComponent<TableArrowProps> = (props) => {
  const { direction, faded } = props
  const { colors } = useTheme()
  return (
    <IconWrapper faded={faded} {...props} style={{ background: colors.gray10 }}>
      {direction === ArrowDirection.LEFT ? <ChevronLeft color={colors.white} /> : <ChevronRight color={colors.white} />}
    </IconWrapper>
  )
}

export default TableArrow
